"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Recipients/RecipientsScreen.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);




var _broadcast = require('shared/enum/broadcast');
var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _actionCreators = require('shared/actions/actionCreators'); var _actionCreators2 = _interopRequireDefault(_actionCreators);
var _useBus = require('shared/hooks/useBus'); var _useBus2 = _interopRequireDefault(_useBus);
var _campaignRecipientsAdd = require('shared/services/campaignRecipientsAdd');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _campaignState = require('web/screens/Broadcast/campaignState');
var _format = require('web/screens/Broadcast/format');
var _helpers = require('web/screens/Broadcast/Wizard/helpers');
var _useCampaignSchedule = require('web/screens/Broadcast/useCampaignSchedule'); var _useCampaignSchedule2 = _interopRequireDefault(_useCampaignSchedule);
var _addingRecipients = require('web/screens/Broadcast/addingRecipients');

var _Spinner = require('web/components/Spinner');
var _DisabledReason = require('web/screens/Broadcast/DisabledReason'); var _DisabledReason2 = _interopRequireDefault(_DisabledReason);
var _AddProgress = require('./AddProgress'); var _AddProgress2 = _interopRequireDefault(_AddProgress);
var _RecipientTable = require('web/screens/Broadcast/RecipientTable'); var _RecipientTable2 = _interopRequireDefault(_RecipientTable);
var _RemoveConfirmationModal = require('web/screens/Broadcast/CampaignPage/Body/MessagesTable/BulkControls/RemoveConfirmationModal'); var _RemoveConfirmationModal2 = _interopRequireDefault(_RemoveConfirmationModal);
var _RecipientsRow = require('./RecipientsRow'); var _RecipientsRow2 = _interopRequireDefault(_RecipientsRow);
var _VariableHeaders = require('./VariableHeaders'); var _VariableHeaders2 = _interopRequireDefault(_VariableHeaders);
var _VariableDialog = require('./VariableDialog'); var _VariableDialog2 = _interopRequireDefault(_VariableDialog);
var _EditRecipientDialog = require('./EditRecipientDialog'); var _EditRecipientDialog2 = _interopRequireDefault(_EditRecipientDialog);
var _useRecipientColumns = require('./useRecipientColumns'); var _useRecipientColumns2 = _interopRequireDefault(_useRecipientColumns);
var _useRecipientsView = require('./useRecipientsView'); var _useRecipientsView2 = _interopRequireDefault(_useRecipientsView);

const SEARCH_DELAY_MS = 300

const STATUS_LABELS = [
  [_broadcast.broadcastMsgStatus.NOT_SCHEDULED, 'Not scheduled'],
  [_broadcast.broadcastMsgStatus.QUEUED, 'Queued'],
  [_broadcast.broadcastMsgStatus.PROCESSING, 'Processing'],
  [_broadcast.broadcastMsgStatus.COMPLETED, 'Completed'],
  [_broadcast.broadcastMsgStatus.FAILED, 'Failed'],
  [_broadcast.broadcastMsgStatus.AWAITING_CONSENT, 'Waiting for consent'],
]

const filterValue = (f) => f.kind === 'status' ? `status:${f.status}` : f.kind
const filterOf = (value) => value.startsWith('status:')
  ? { kind: 'status', status: value.slice('status:'.length)  }
  : { kind: value  }

// Not yet being messaged, so they can still be removed (or taken off the queue).
const isSelectable = (status) =>
  status === _broadcast.broadcastMsgStatus.NOT_SCHEDULED || status === _broadcast.broadcastMsgStatus.QUEUED

const ADD_SUCCESS = [_actionCreators2.default.addCampaignRecipientsActions.SUCCESS.type]

















/* Rev 31 v2: the recipients screen the create wizard's Recipients step and
 * the campaign page share. Only what's above it (the title row or the
 * campaign's controls) and below it (the wizard's footer) differ. Rows are
 * the campaign's own: an Add saves at once, so leaving and coming back
 * shows the same list. */
const RecipientsScreen = ({
  campaign, emptyAction, progress = null, onAddFromCsv, onRemovePatients, onDequeuePatients,
}) => {
  const hasStarted = _campaignState.hasCampaignStarted.call(void 0, campaign)
  const isEmpty = _campaignState.campaignRecipientCount.call(void 0, campaign) === 0
  // Rev 32 V4: variables can be added and their defaults changed after
  // sending starts (they reach the recipients not yet sent).
  const canChangeVariables = !campaign.Archived
  // P2': not while a background Add writes (the server refuses it).
  const isAddingRecipients = _addingRecipients.useIsAddingRecipients.call(void 0, campaign.CampaignKey)
  const variablesBlocked = isAddingRecipients ? _addingRecipients.WAIT_FOR_ADD_REASON : null

  const [filter, setFilter] = _react.useState(_useRecipientsView.ALL)
  const [search, setSearch] = _react.useState.call(void 0, '')
  const [query, setQuery] = _react.useState.call(void 0, '')
  // P2' (decision 28): when this tab starts a background Add, its filter and
  // search go back to everyone, so the rows can be seen arriving. Other tabs
  // only get the push, and keep theirs.
  const { CampaignKey } = campaign
  const onAddStarted = _react.useCallback.call(void 0, 
    (action) => {
      const payload = (action ).payload
      if (!payload || !_campaignRecipientsAdd.isBackgroundAddReply.call(void 0, payload) || payload.Add.CampaignKey !== CampaignKey) return
      setFilter(_useRecipientsView.ALL)
      setSearch('')
      setQuery('')
    },
    [CampaignKey],
  )
  _useBus2.default.call(void 0, ADD_SUCCESS, onAddStarted)
  const [offset, setOffset] = _react.useState.call(void 0, 0)
  _react.useEffect.call(void 0, 
    () => {
      const timer = setTimeout(() => setQuery(search.trim()), SEARCH_DELAY_MS)
      return () => clearTimeout(timer)
    },
    [search],
  )
  // A new filter or search starts at the first page, in the same read.
  const pageKey = `${filterValue(filter)}\u0000${query}`
  const [shownKey, setShownKey] = _react.useState.call(void 0, pageKey)
  if (pageKey !== shownKey) {
    setShownKey(pageKey)
    setOffset(0)
  }

  const { view, counts, isLoading, error } = _useRecipientsView2.default.call(void 0, campaign, filter, query, offset)
  const { columns, onMove } = _useRecipientColumns2.default.call(void 0, campaign)
  const rows = _react.useMemo.call(void 0, () => _nullishCoalesce(_optionalChain([view, 'optionalAccess', _ => _.Rows]), () => ( [])), [view])
  const total = _nullishCoalesce(_optionalChain([view, 'optionalAccess', _2 => _2.Total]), () => ( 0))
  // A page past the end (rows went) steps back to the last one with rows.
  _react.useEffect.call(void 0, 
    () => {
      if (view && offset > 0 && offset >= view.Total) setOffset(Math.max(0, Math.floor((view.Total - 1) / _useRecipientsView.PAGE_SIZE) * _useRecipientsView.PAGE_SIZE))
    },
    [view, offset],
  )

  // Selected recipients and their message status, kept across pages.
  const [selected, setSelected] = _react.useState(() => new Map())
  const toggle = _react.useCallback.call(void 0, 
    (key, isOn) => setSelected(s => {
      const next = new Map(s)
      const status = _optionalChain([rows, 'access', _3 => _3.find, 'call', _4 => _4(r => _optionalChain([r, 'access', _5 => _5.Patient, 'optionalAccess', _6 => _6.PatientKey]) === key), 'optionalAccess', _7 => _7.Status])
      if (isOn && status) next.set(key, status)
      else next.delete(key)
      return next
    }),
    [rows],
  )
  const pageKeys = rows.flatMap(r => r.Patient && isSelectable(r.Status) ? [[r.Patient.PatientKey, r.Status] ] : [])
  const pageSelected = pageKeys.filter(([k]) => selected.has(k)).length
  const clearSelection = () => setSelected(new Map())
  const [isConfirmingRemove, setIsConfirmingRemove] = _react.useState.call(void 0, false)
  const selectedKeys = [...selected.keys()]
  const canDequeue = !!onDequeuePatients && selected.size > 0 && [...selected.values()].every(s => s === _broadcast.broadcastMsgStatus.QUEUED)

  // + Add variable, Edit variable…, Remove variable.
  const [variableDialog, setVariableDialog] = _react.useState(null)
  const [variableState, setVariableState] = _react.useState({ isSaving: false, error: null })
  const [variableError, setVariableError] = _react.useState(null)
  const editing = _optionalChain([variableDialog, 'optionalAccess', _8 => _8.editing])
    ? {
        name: variableDialog.editing.name,
        fallback: variableDialog.editing.ownDefault,
        isUsed: variableDialog.editing.isUsed,
        isSent: hasStarted,
      }
    : null
  const onSaveVariable = (name, fallback) => {
    const { CampaignKey } = campaign
    const request = _optionalChain([variableDialog, 'optionalAccess', _9 => _9.editing])
      ? _actions2.default.updateCampaignVariable({ CampaignKey, Name: variableDialog.editing.name, NewName: name, Default: fallback })
      : _actions2.default.addCampaignVariable({ CampaignKey, Name: name, Default: fallback })
    setVariableState({ isSaving: true, error: null })
    request
      .then(() => {
        setVariableState({ isSaving: false, error: null })
        setVariableDialog(null)
      })
      .catch((e) => setVariableState({ isSaving: false, error: _helpers.errorText.call(void 0, e, "Couldn't save the variable") }))
  }
  const onRemoveVariable = (column) => {
    setVariableError(null)
    _actions2.default.removeCampaignVariable({ CampaignKey: campaign.CampaignKey, Name: column.name })
      .catch((e) => setVariableError(_helpers.errorText.call(void 0, e, `Couldn't remove ${column.name}`)))
  }

  // Rev 32 V3: the recipient whose Edit patient dialog is open.
  const [editingRow, setEditingRow] = _react.useState(null)

  const attention = _nullishCoalesce(_optionalChain([counts, 'optionalAccess', _10 => _10.attention]), () => ( 0))
  const isShowingAttention = filter.kind === 'attention'
  const hasAddColumn = canChangeVariables

  const schedule = _useCampaignSchedule2.default.call(void 0, campaign.CampaignKey)
  const filterOptions = [
    ['all', `All · ${_format.formatCount.call(void 0, _nullishCoalesce(_optionalChain([counts, 'optionalAccess', _11 => _11.all]), () => ( _campaignState.campaignRecipientCount.call(void 0, campaign))))}`],
    ...(!hasStarted ? [['ready', `Ready · ${_format.formatCount.call(void 0, _nullishCoalesce(_optionalChain([counts, 'optionalAccess', _12 => _12.ready]), () => ( 0)))}`] ] : []),
    ['attention', `Needs attention · ${_format.formatCount.call(void 0, attention)}`],
    ...(hasStarted
      ? STATUS_LABELS
          .filter(([status]) => (_nullishCoalesce(campaign.Stats[status], () => ( 0))) > 0 || (filter.kind === 'status' && filter.status === status))
          // Rev 27 P2: queued messages waiting for their start read Scheduled.
          .map(([status, label]) => [
            `status:${status}`,
            `${status === _broadcast.broadcastMsgStatus.QUEUED && schedule.state ? 'Scheduled' : label} · ${_format.formatCount.call(void 0, _nullishCoalesce(campaign.Stats[status], () => ( 0)))}`,
          ] )
      : []),
  ]

  return (
    _react2.default.createElement('div', { className: "recipients-screen", __self: this, __source: {fileName: _jsxFileName, lineNumber: 205}}
      , _react2.default.createElement(_AddProgress2.default, { campaignKey: campaign.CampaignKey, onAddFromCsv: onAddFromCsv, __self: this, __source: {fileName: _jsxFileName, lineNumber: 206}} )
      ,  progress 
      ,  attention > 0 && !isEmpty && (
        _react2.default.createElement('div', { role: "status", 'aria-label': "Recipients needing attention"  , className: "recipients-notice", __self: this, __source: {fileName: _jsxFileName, lineNumber: 209}}
          , _react2.default.createElement('span', { className: "recipients-notice--icon", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 210}}, "⚠")
          , _react2.default.createElement('span', { className: "recipients-notice--text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 211}}
            , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 212}},  _format.pluralize.call(void 0, attention, 'recipient needs', 'recipients need') , " attention." )
            ,  ' ' , "They're skipped when you send unless you fix them."
          )
          , _react2.default.createElement('button', {
            type: "button",
            className: "recipients-notice--action",
            onClick: () => setFilter(isShowingAttention ? _useRecipientsView.ALL : { kind: 'attention' }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 215}}

            ,  isShowingAttention ? 'Show everyone' : 'Show them' 
          )
        )
      )
      ,  !isEmpty && (selected.size > 0
        ? (
            _react2.default.createElement('div', { role: "toolbar", 'aria-label': "Selected recipients" , className: "recipients-toolbar recipients-toolbar--selection" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 226}}
              , _react2.default.createElement('span', { className: "recipients-toolbar--count", __self: this, __source: {fileName: _jsxFileName, lineNumber: 227}},  _format.formatCount.call(void 0, selected.size) , " selected" )
              , _react2.default.createElement('button', { type: "button", className: "recipients-toolbar--clear", onClick: clearSelection, __self: this, __source: {fileName: _jsxFileName, lineNumber: 228}}, "Clear")
              , _react2.default.createElement('span', { className: "recipients-toolbar--grow", __self: this, __source: {fileName: _jsxFileName, lineNumber: 229}} )
              ,  canDequeue && (
                _react2.default.createElement('button', {
                  type: "button",
                  className: "recipients-toolbar--action",
                  onClick: () => {
                    _optionalChain([onDequeuePatients, 'optionalCall', _13 => _13(selectedKeys)])
                    clearSelection()
                  }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 231}}
, "Remove from queue"

                )
              )
              , _react2.default.createElement('button', {
                type: "button",
                className: "recipients-toolbar--action recipients-toolbar--action--danger" ,
                disabled: campaign.Archived,
                title: campaign.Archived ? "Can't remove patients from an archived campaign" : undefined,
                onClick: () => setIsConfirmingRemove(true), __self: this, __source: {fileName: _jsxFileName, lineNumber: 242}}
, "Remove "
                 ,  _format.pluralize.call(void 0, selected.size, 'recipient', 'recipients') 
              )
            )
          )
        : (
            _react2.default.createElement('div', { className: "recipients-toolbar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 254}}
              , _react2.default.createElement('label', { className: "recipients-toolbar--filter", __self: this, __source: {fileName: _jsxFileName, lineNumber: 255}}
                , _react2.default.createElement('img', { src: "/assets/icons/filter-grey.svg", alt: "", className: "recipients-toolbar--filter-icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 256}} )
                , _react2.default.createElement('select', {
                  'aria-label': "Filter recipients" ,
                  value: filterValue(filter),
                  onChange: e => setFilter(filterOf(e.target.value)), __self: this, __source: {fileName: _jsxFileName, lineNumber: 257}}

                  ,  filterOptions.map(([value, label]) => _react2.default.createElement('option', { key: value, value: value, __self: this, __source: {fileName: _jsxFileName, lineNumber: 262}},  label )) 
                )
              )
              , _react2.default.createElement('label', { className: "recipients-toolbar--search", __self: this, __source: {fileName: _jsxFileName, lineNumber: 265}}
                , _react2.default.createElement('img', { src: "/assets/icons/search-grey.svg", alt: "", className: "recipients-toolbar--search-icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 266}} )
                , _react2.default.createElement('input', {
                  type: "search",
                  'aria-label': "Search recipients" ,
                  placeholder: "Search recipients" ,
                  value: search,
                  onChange: e => setSearch(e.target.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 267}}
                )
              )
            )
          )
      )
      , _react2.default.createElement(_RecipientTable2.default, {
        selectAll: {
          isChecked: pageKeys.length > 0 && pageSelected === pageKeys.length,
          isMixed: pageSelected > 0 && pageSelected < pageKeys.length,
          isDisabled: pageKeys.length === 0,
          onChange: isOn => setSelected(s => {
            const next = new Map(s)
            pageKeys.forEach(([k, status]) => isOn ? next.set(k, status) : next.delete(k))
            return next
          }),
        },
        hasTimes: hasStarted,
        hasTags: true,
        variableHeaders: (
          _react2.default.createElement(_VariableHeaders2.default, {
            columns: columns,
            onMoveColumn: onMove,
            onEdit: canChangeVariables ? c => setVariableDialog({ editing: c }) : null,
            onRemove: canChangeVariables ? onRemoveVariable : null,
            disabledReason: variablesBlocked, __self: this, __source: {fileName: _jsxFileName, lineNumber: 292}}
          )
        ),
        variableCount: columns.length,
        trailingHeader: hasAddColumn && (
          _react2.default.createElement(_DisabledReason2.default, { reason: variablesBlocked, __self: this, __source: {fileName: _jsxFileName, lineNumber: 302}}
            , _react2.default.createElement('button', {
              type: "button",
              className: "recipients-add-variable",
              'aria-label': "Add variable" ,
              title: variablesBlocked ? undefined : 'Add variable',
              disabled: !!variablesBlocked,
              onClick: () => setVariableDialog({ editing: null }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 303}}
, "+"

            )
          )
        ),
        hasItems: !isEmpty && rows.length > 0,
        isBusy: isLoading,
        page: Math.floor(offset / _useRecipientsView.PAGE_SIZE),
        emptyClassName: isEmpty ? 'recipients-empty' : undefined,
        emptyState: isEmpty
          ? (
              _react2.default.createElement('div', { className: "recipients-empty--inner", __self: this, __source: {fileName: _jsxFileName, lineNumber: 321}}
                , _react2.default.createElement('div', { className: "recipients-empty--icon", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 322}}
                  , _react2.default.createElement('img', { src: "/assets/icons/add-participant-black.svg", alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 323}} )
                )
                , _react2.default.createElement('div', { className: "recipients-empty--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 325}}, "No recipients yet"  )
                , _react2.default.createElement('div', { className: "recipients-empty--hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 326}}, "Add patients from your directory, or upload a CSV with their details and any message variables."

                )
                ,  emptyAction 
              )
            )
          : isLoading && !view
            ? _react2.default.createElement(_Spinner.SimpleSpinner, { className: "campaign--table--spinner", __self: this, __source: {fileName: _jsxFileName, lineNumber: 333}} )
            : _react2.default.createElement('span', { className: "recipients-screen--no-match", __self: this, __source: {fileName: _jsxFileName, lineNumber: 334}}, "No recipients match."  ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 278}}

        ,  !isEmpty && rows.map(row => (
              _react2.default.createElement(_RecipientsRow2.default, {
                key: `${row.SourceIndex}:${row.Row}:${_nullishCoalesce(_optionalChain([row, 'access', _14 => _14.Patient, 'optionalAccess', _15 => _15.PatientKey]), () => ( ''))}`,
                campaign: campaign,
                row: row,
                columns: columns,
                hasStarted: hasStarted,
                hasAddColumn: hasAddColumn,
                isSelected: !!row.Patient && selected.has(row.Patient.PatientKey),
                onToggle: isSelectable(row.Status) ? toggle : null,
                onEdit: setEditingRow, __self: this, __source: {fileName: _jsxFileName, lineNumber: 337}}
              )
            ))
      )
      , _react2.default.createElement(_RecipientTable.RecipientPager, {
        page: Math.floor(offset / _useRecipientsView.PAGE_SIZE),
        pageCount: Math.ceil(total / _useRecipientsView.PAGE_SIZE),
        onPage: page => setOffset(page * _useRecipientsView.PAGE_SIZE), __self: this, __source: {fileName: _jsxFileName, lineNumber: 350}}
      )
      ,  (error || variableError) && (
        _react2.default.createElement('p', { role: "alert", className: _classBuilder2.default.call(void 0, 'broadcast-wizard--error', 'recipients-screen--error'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 356}},  error || variableError )
      )
      , _react2.default.createElement(_RemoveConfirmationModal2.default, {
        isOpen: isConfirmingRemove,
        patientsCount: selected.size,
        onClose: () => setIsConfirmingRemove(false),
        onConfirm: () => {
          onRemovePatients(selectedKeys)
          clearSelection()
        }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 358}}
      )
      , _react2.default.createElement(_EditRecipientDialog2.default, { campaign: campaign, row: editingRow, columns: columns, onClose: () => setEditingRow(null), __self: this, __source: {fileName: _jsxFileName, lineNumber: 367}} )
      , _react2.default.createElement(_VariableDialog2.default, {
        isOpen: !!variableDialog,
        editing: editing,
        existing: campaign.TemplateFields.map(f => f.Name),
        isSaving: variableState.isSaving,
        error: variableState.error,
        onClose: () => {
          setVariableDialog(null)
          setVariableState({ isSaving: false, error: null })
        },
        onSave: onSaveVariable, __self: this, __source: {fileName: _jsxFileName, lineNumber: 368}}
      )
    )
  )
}

exports. default = _react.memo.call(void 0, RecipientsScreen)
